import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { FooterSimple, LoggedOutHeader, SkipToMain } from '../components';

interface Props {
  children: React.ReactNode;
}

export default function LoggedOutSimpleLayout({ children }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SkipToMain id="main" />
      <LoggedOutHeader transparent />

      <main id="main" className={classes.content}>
        {children}
      </main>

      <FooterSimple />
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background:
      'linear-gradient(357deg, #FAFAFA 15.69%, rgba(255, 255, 255, 0.10) 97.58%), linear-gradient(90deg, rgba(15, 127, 217, 0.25) 3.8%, rgba(21, 131, 218, 0.25) 29.89%, rgba(80, 230, 255, 0.25) 62.58%, rgba(174, 113, 241, 0.25) 87.58%)',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },
});
